
<!--
 * @Description: 教职工详情 语言能力
 * @Author: 张天伟
 * @Date: 2023-03-08 11:59:14
 * @LastEditors: PF
 * @LastEditTime: 2023-03-10 17:55:44
-->
<template>
  <div>
    <el-descriptions class="descript-box" v-for="(item, index) in tableData" :key="index" :column="4" border>
      <el-descriptions-item label="外国语种" label-align="right" align="left" width="150px" span="2">{{item.wgyz}}</el-descriptions-item>
      <el-descriptions-item label="外国语种熟练程度" label-align="right" align="left" width="150px" span="2">{{item.wgyzslcdbt}}</el-descriptions-item>
      <el-descriptions-item label="中国语种" label-align="right" align="left" width="150px" span="2">{{item.zgyz}}</el-descriptions-item>
      <el-descriptions-item label="中国语种熟练程度" label-align="right" align="left" width="150px" span="2">{{item.zgyzslcdbt}}</el-descriptions-item>
      <el-descriptions-item label="普通话水平等级" label-align="right" align="left" width="150px" span="4">{{item.pthspdjbt}}</el-descriptions-item>
      <el-descriptions-item label="" label-align="right" align="left" span="4"></el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({ row: { type: Object, required: false } })
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = {
        url: '/api/v2/renliziyuan/jiaozhigongyuyannengli/list',
        data: { id: props.row.id, order: 'gh', sort: 'asc' }
      }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
